import {put,takeLatest,call} from 'redux-saga/effects';
import * as userService from "../../../services/userService";
import {
    REMOVE_FAVORITE_VENUE,
    REMOVE_FAVORITE_VENUE_SUCCESS,
    REMOVE_FAVORITE_VENUE_ERROR,
}
    from "../../actions/user";

function* removeFavoriteVenueSaga(action) {
    try {

        const data = yield call(userService.RemoveFavoriteVenue,action.payload)

        if(data)
            yield put({
                type: REMOVE_FAVORITE_VENUE_SUCCESS,
                payload: action.payload.venue
            });
        else
            yield put({
                type: REMOVE_FAVORITE_VENUE_ERROR,error: 'Error while remove favorite venue'
            });



    } catch(error) {
        yield put({
            type: REMOVE_FAVORITE_VENUE_ERROR,error: error.data
        });
    }
}


export function* removeFavoriteVenueSagaWatcher() {
    yield takeLatest(REMOVE_FAVORITE_VENUE,removeFavoriteVenueSaga);
}